





















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { ReferralStats } from '@/api/model/referral-stats'
const referrals = namespace('referrals')

@Component
export default class ReferralCharts extends Vue {
    @referrals.State readonly loading!: boolean
    @referrals.State readonly referralStats!: ReferralStats
    @referrals.State readonly pipelineFilter!: string

    get showPipelineChart(): boolean {
        return false
    }

    get showPhaseCategoryChart(): boolean {
        return this.pipelineFilter === null
    }

    get showPhasesChart(): boolean {
        return this.pipelineFilter !== null
    }

    get hasAnyChartData(): boolean {
        return this.referralStats.hasAgeData
            || this.referralStats.hasScoreData
            || this.referralStats.hasPipelineData
    }
}
